export enum InterventionStatus {
  InstallationRequested = "installationRequested",
  InstallationToDo = "installationToDo",
  InstallationInProgress = "installationInProgress",
  SignEquipment = "signEquipment",
  /** = Ticket closed */
  InstallationCompleted = "installationCompleted",
  ToUninstall = "toUninstall",
  AddKiosk = "addKiosk",
  ToBeModified = "toBeModified",
  SwappToDo = "swappToDo",
  InstallationNotPossible = "installationNotPossible",
  ShopClosed = "shopClosed",
  HsNoPayment = "hsNoPayment",
  Support = "support",
  BToBetMigration = "bToBetMigration",
  BToBetMigrationDone = "bToBetMigrationDone",
  NewKioskMigration = "newKioskMigration",
  NewKioskMigrationDone = "newKioskMigrationDone",
}

export const CompletedInterventionStatus = [
  InterventionStatus.InstallationCompleted,
];
